<template>
	<div class="ability-detail">
		<!-- :style="musicFlag && {
      marginTop: '15px'
    }"  -->
		<div class="ability-detail-header" @click="routeBack">
			<i class="el-icon-arrow-left" style="margin-right: 5px;font-weight: 1000;"></i>返回
		</div>

		<div class="ability-detail-subheader" v-if="createdFlag">
			<div class="flex-align-center" style="flex: 1;">
				<div class="ability-detail-num" style="white-space: nowrap;">题目编号</div>
				<div class="flex-center-center ability-detail-id">{{ detailData.id || startIndex }}</div>
				<div class="flex-align-center ability-detail-row">
					<!-- <div style="white-space: nowrap;">
						{{ valueKeyLabel(detailData.apply_grade, apply_grade)
						}}{{ valueKeyLabel(detailData.apply_volume, fb_apply_volume) }}&ensp;&ensp;|&ensp;&ensp;
					</div> -->
					<el-tooltip
						placement="top"
						effect="light"
						_overflow="hidden"
						style="white-space: nowrap; text-overflow: ellipsis; max-width: 200px;"
					>
						<div slot="content">
							{{ detailData.competence_array?.map(item => item.knowledge_name).join('、') || '未设置' }}
						</div>
						<div>
							能力点：{{ detailData.competence_array?.map(item => item.knowledge_name).join('、') || '未设置' }}
						</div>
					</el-tooltip>

					&ensp;&ensp;|&ensp;&ensp;

					<el-tooltip
						placement="top"
						effect="light"
						_overflow="hidden"
						style="white-space: nowrap; text-overflow: ellipsis; max-width: 200px;"
					>
						<div slot="content">
							{{ detailData.knowledge_array?.map(item => item.knowledge_name).join('、') || '未设置' }}
						</div>
						<div>知识点：{{ detailData.knowledge_array?.map(item => item.knowledge_name).join('、') || '未设置' }}</div>
					</el-tooltip>

					&ensp;&ensp;|&ensp;&ensp;
					<div style="white-space: nowrap;">难度：{{ detailData.difficulty }}</div>
				</div>
			</div>

			<div class="flex-align-center">
        <!-- 翻页数量当前页数（反转）暂时隐藏 -->
				<div class="ability-detail-total" v-if="!checkVisible">{{ index }}/{{ total }}</div>
				<!-- <div class="flex-center-center ability-detail-icon-left" @click="routeJump(checkPage.prev, index - 1)">
					<i class="el-icon-arrow-left"></i>
				</div>
        <div class="flex-center-center ability-detail-icon-right" @click="routeJump(checkPage.next, index + 1)">
					<i class="el-icon-arrow-right"></i>
				</div> -->
				<el-button
					icon="el-icon-arrow-left"
					class="flex-center-center ability-detail-icon-left button"
					@click="routeJump(checkPage.prev, index - 1)"
					:disabled="(index == 1 || waitVisible)"
					v-if="!checkVisible"
				></el-button>

				<el-button
					icon="el-icon-arrow-right"
					class="flex-center-center ability-detail-icon-left button"
					@click="routeJump(checkPage.next, index + 1)"
					:disabled="(index == total || waitVisible)"
					v-if="!checkVisible"
				></el-button>
				<el-button
					icon="el-icon-edit-outline"
					class="flex-center-center ability-detail-button button"
					@click="routePush('edit', detailData)"
					v-if="
						($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && (params?.scope_type == 1 || scope_type == 1)) ||
						($store.state.user.userInfo.type === $api.account.types.TEACHER.value && (params?.scope_type == 5 || scope_type == 5)) ||
						($store.state.user.userInfo.type === $api.account.types.OTHER.value && (params?.scope_type == 1 || scope_type == 1) && $permissions([`SP5100_${yy_ms}_4`])) ||
            ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && (params?.scope_type == 2 || scope_type == 2))
					"
					>编辑</el-button
				>
				<el-button
					@click="twoConfirmClick"
					icon="el-icon-delete"
					class="flex-center-center ability-detail-button button"
					v-if="
						($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && (params?.scope_type == 1 || scope_type == 1)) ||
						($store.state.user.userInfo.type === $api.account.types.TEACHER.value && (params?.scope_type == 5 || scope_type == 5)) ||
						($store.state.user.userInfo.type === $api.account.types.OTHER.value && (params?.scope_type == 1 || scope_type == 1) && $permissions([`SP5100_${yy_ms}_5`])) ||
            ($store.state.user.userInfo.type === $api.account.types.RESEARCH.value && (params?.scope_type == 2 || scope_type == 2))
					"
					>删除</el-button
				>
			</div>
		</div>

		<div class="ability-detail-body" v-if="connectFormFlag">
			<div class="ability-detail-body-title">{{ filterBody }}</div>
			<div _flex="~ wrap">
				<div class="ability-detail-resource" v-for="(item, index) in srcResource" :key="index">
					<audio
						class="ability-detail-audio"
						controls
						:src="item.src"
						v-if="item.type === 'audio'"
						controlslist="noplaybackrate nodownload"
					></audio>
					<video
						class="ability-detail-audio"
						controls
						:src="item.src"
						v-else-if="item.type === 'video'"
						controlslist="noplaybackrate nodownload"
            style="max-height:500px"
					></video>
					<img :src="item.src" v-else />
				</div>
			</div>
			<connectLine
				:groupNumber="detailData.extras[1]?.groupNum"
				:items="branches"
				:connections="detailData.answer"
				:itemsEditable="false"
				:disabled="true"
				style="min-width: 820px;"
				:htmlClickImage="htmlClickImage"
			/>
		</div>

		<!-- <iframe
			v-if="iframeFlag"
			src="http://localhost:8080/assets/exam-frontend/#/exercises"
			scrolling="auto"
			:allowfullscreen="true"
			width="100%"
			:height="iframeHeight"
			ref="iframe"
			frameborder="0"
			@load="loaded"
		></iframe> -->

		<div class="ability-detail-body" v-if="moreRadioFormFlag || radioFormFlag">
			<div class="ability-detail-body-title">{{ filterBody }}</div>
			<div _flex="~ wrap">
				<div class="ability-detail-resource" v-for="(item, index) in srcResource" :key="index">
					<audio
						class="ability-detail-audio"
						controls
						:src="item.src"
						v-if="item.type === 'audio'"
						controlslist="noplaybackrate nodownload"
					></audio>
					<video
						class="ability-detail-audio"
						controls
						:src="item.src"
						v-else-if="item.type === 'video'"
						controlslist="noplaybackrate nodownload"
            style="max-height:500px"
					></video>
					<img :src="item.src" v-else />
				</div>
			</div>

			<div v-if="radioFormFlag" class="gird">
				<div
					:class="['ability-detail-radio', detailData.answer === index && 'ability-detail-radio-active']"
					v-for="(item, index) in branches"
					:key="index"
				>
					<img
            v-if="detailData.answer === index"
						:src="require(`@/assets/image/select.png`)"
						width="16px"
						height="16px"
            style="border-radius: 100%;"
					/>
          <div v-else _w="16px" _h="16px" style="border-radius: 100%;border:1px solid #B0B0B0"></div>
					<div class="radio-item" v-html="item" @click="htmlClickImage"></div>
				</div>
			</div>
			<div v-else class="gird">
				<div
					:class="[
						'ability-detail-radio',
						detailData.answer.some(item => item === index) && 'ability-detail-radio-active'
					]"
					v-for="(item, index) in branches"
					:key="index"
				>
					<img
						:src="
							require(`@/assets/image/${detailData.answer.some(item => item === index) ? 'select' : 'no-select'}.png`)
						"
						width="16px"
						height="16px"
					/>
					<div class="radio-item" v-html="item" @click="htmlClickImage"></div>
				</div>
			</div>
		</div>

		<div class="ability-detail-body" v-if="gapFormFlag">
			<div class="ability-detail-body-title" v-html="filterBody" @click="htmlClickImage"></div>
		</div>

		<div class="ability-detail-body" :style="{ minWidth: [5, 7, 18, 24].includes(detailData.type) ? '-webkit-fill-available' : '' }" v-if="singFormFlag">
			<div class="ability-detail-body-title" v-html="filterBody" _text="!24px [#3E3E3E]"></div>
			<div _flex="~ wrap">
				<div class="ability-detail-resource" v-for="(item, index) in srcResource" :key="index">
					<audio
						class="ability-detail-audio"
						controls
						:src="item.src"
						v-if="item.type === 'audio'"
						controlslist="noplaybackrate nodownload"
					></audio>
					<video
						class="ability-detail-audio"
						controls
						:src="item.src"
						v-else-if="item.type === 'video'"
						controlslist="noplaybackrate nodownload"
            style="max-height:500px"
					></video>
					<img :src="item.src" v-else />
				</div>
			</div>
			<img v-if="musicFlag && detailData.type == 9 && detailData?.extras[1]" :src="require('@/assets/image/sing.jpg')" width="1080px" height="96px" _m="b-15px" />
      <div :class="[[5, 7, 18].includes(detailData.type) ? 'ability-detail-body-center' : '']">
        <div _w="!1000px" _flex="~ col justify-center items-center" _pos="relative">
          <iframe
            :src="`${RESOURCE_URL}?music_id=${detailData.musical_id}&isScreening=${false}`"
            width="1920"
            ref="iframe"
            @load="loadChange"
            frameborder="0"
            v-if="musicFlag && [7, 9, 18, 5].includes(detailData.type)"
            :style="`transform: scale(0.530749); transform-origin: center top; margin-bottom: ${iframeMarginBottom};min-height: ${iframeMinHeight}px`"
          ></iframe>
          <iframe
            :src="`${RESOURCE_URL.replace('music_score_display.html', 'music_score_rhythm.html')}?isThumb=${false}&music_id=${detailData.musical_id}&isScreening=`"
            width="1920"
            ref="iframe"
            @load="loadChange"
            frameborder="0"
            v-if="musicFlag && detailData.type == 4"
            :style="`transform: scale(0.530749); transform-origin: center top; margin-bottom: ${iframeMarginBottom};min-height: ${iframeMinHeight}px`"
          ></iframe>
            <!-- :src="`http://localhost:1234/test/strum_dev.html?isThumb=${false}&music_id=${detailData.musical_id}&isScreening=`" -->
          <iframe
            :src="`${RESOURCE_URL.replace('music_score_display.html', 'music_score_strum.html')}?isThumb=${false}&music_id=${detailData.musical_id}&isScreening=`"
            width="1920"
            ref="iframe"
            @load="loadChange"
            frameborder="0"
            v-if="musicFlag && detailData.type == 24"
            :style="`transform: scale(0.530749); transform-origin: center top; margin-bottom:-40%;height: ${980}px`"
          ></iframe>
          <div
            v-if="!musicFlag && hasMusicVisible"
            _w="1920"
            _h="1080"
            style="transform: scale(0.530749); transform-origin: center top; margin-bottom: -50%;"
          ></div>
          <div v-if="detailData.type == 18" _flex="~ wrap" _w="!1000px" _border="3px solid [#F5F5F5] rounded-[10px]" _p="t-35px x-40px">
            <div
              v-for="item in [...detailData.extras[1], ...(detailData?.extras[2] || [])]" :key="item.midi"
              @click="playMidiNoteWithWebAudio(item)"
              style="box-shadow:0 0 5px 10px #BEDC79"
              _bg="[#88B03F]"
              _border="rounded-[9px]"
              _text="18px [#FFFFFF]"
              _w="80px"
              _h="80px"
              _flex="~ justify-center items-center"
              _m="r-30px b-35px"
              _cursor="pointer"
            >{{ item.cm?.toLowerCase() }}</div>
          </div>
          <div
            v-if="musicFlag && musicBtnFlag"
            _w="206px"
            _h="49px"
            _bg="[#FFF4F0]"
            _border="rounded-41px"
            _text="24px [#FF5E2A] bold"
            _flex="~ justify-center items-center"
            _cursor="pointer"
            :style="{ marginTop: detailData.type == 18 ? '30px' : '0' }"
            @click="musicPlay"
          >
            {{ playStop ? '停止' : '播放乐谱' }}
          </div>
        </div>
      </div>
		</div>


    <!-- 排序 -->
    <div class="ability-detail-body" style="min-width: -webkit-fill-available" v-if="detailData.type == 10">
			<div class="ability-detail-body-title">{{ filterBody }}</div>
			<div _flex="~ wrap">
				<div class="ability-detail-resource" v-for="(item, index) in srcResource" :key="index">
					<audio
						class="ability-detail-audio"
						controls
						:src="item.src"
						v-if="item.type === 'audio'"
						controlslist="noplaybackrate nodownload"
					></audio>
					<video
						class="ability-detail-audio"
						controls
						:src="item.src"
						v-else-if="item.type === 'video'"
						controlslist="noplaybackrate nodownload"
            style="max-height:500px"
					></video>
					<img :src="item.src" v-else />
				</div>
			</div>
      <div _flex="~ col items-center">
        <div
          :class="[
            'ability-detail-radio',
          ]"
          v-for="(item, index) in branches"
          :key="index"
          style="width:600px"
        >
          <div _w="30px" _h="30px" _bg="[#F5F5F5]" _flex="~ items-center justify-center" _border="rounded-[4px]">{{ index + 1 }}</div>
          <div class="radio-item" v-html="item" @click="htmlClickImage"></div>
        </div>
      </div>
		</div>

    <!-- 配色 -->
    <div class="ability-detail-body" style="min-width: -webkit-fill-available" v-if="detailData.type == 14">
			<div class="ability-detail-body-title">{{ filterBody }}</div>
			<div _flex="~ wrap">
				<div class="ability-detail-resource" v-for="(item, index) in srcResource" :key="index">
					<audio
						class="ability-detail-audio"
						controls
						:src="item.src"
						v-if="item.type === 'audio'"
						controlslist="noplaybackrate nodownload"
					></audio>
					<video
						class="ability-detail-audio"
						controls
						:src="item.src"
						v-else-if="item.type === 'video'"
						controlslist="noplaybackrate nodownload"
            style="max-height:500px"
					></video>
					<img :src="item.src" v-else />
				</div>
			</div>
      <div _flex="~ justify-center col items-center">
        <matchColor mode="look" :interfereColor="detailData.extras[1]" v-model="detailData.extras[0]"/>
        <div _p="l-10px" _text="[#666666]" _bg="[#F9F9F9]" :style="{
          borderLeft: 'solid rgba(0, 0, 0, 0.2) 1px',
          borderRight: 'solid rgba(0, 0, 0, 0.2) 1px',
          height: '40px',
          lineHeight: '40px'
        }" _w="733px">可填入颜色</div>
        <fillColor mode="look" :correct-color.sync="detailData.extras[0]" v-model="detailData.extras[1]" />
      </div>
		</div>

    <!-- 拼图 -->
    <div class="ability-detail-body" style="min-width: -webkit-fill-available" v-if="detailData.type == 13">
			<div class="ability-detail-body-title">{{ filterBody }}</div>
			<div _flex="~ wrap">
				<div class="ability-detail-resource" v-for="(item, index) in srcResource" :key="index">
					<audio
						class="ability-detail-audio"
						controls
						:src="item.src"
						v-if="item.type === 'audio'"
						controlslist="noplaybackrate nodownload"
					></audio>
					<video
						class="ability-detail-audio"
						controls
						:src="item.src"
						v-else-if="item.type === 'video'"
						controlslist="noplaybackrate nodownload"
            style="max-height:500px"
					></video>
					<img :src="item.src" v-else />
				</div>
			</div>
      <div _flex="~ justify-center">
        <div class="puzzle-board" ref="puzzleBoard"/>
      </div>
		</div>

		<div v-if="detailData.type === 15">
			<!-- TODO -->
			创编题
		</div>

    <!-- 填充 -->
    <div class="ability-detail-body" style="min-width: -webkit-fill-available" v-if="detailData.type === 12">
			<div class="ability-detail-body-title">{{ filterBody }}</div>
			<div _flex="~ wrap">
				<div class="ability-detail-resource" v-for="(item, index) in srcResource" :key="index">
					<audio
						class="ability-detail-audio"
						controls
						:src="item.src"
						v-if="item.type === 'audio'"
						controlslist="noplaybackrate nodownload"
					></audio>
					<video
						class="ability-detail-audio"
						controls
						:src="item.src"
						v-else-if="item.type === 'video'"
						controlslist="noplaybackrate nodownload"
            style="max-height:500px"
					></video>
					<img :src="item.src" v-else />
				</div>
			</div>
      <div  _flex="~ col items-center">
        <colorFill :question="detailData" :mode="'look'"/>
      </div>
		</div>

		<div _h="100px" _w="full"></div>

    <statistics
			_m="l-58px t-20px r-10px"
			v-if="$store.state.user.userInfo.type === $api.account.types.TEACHER.value"
			:detailData="detailData"
      :puzzleBase64Array="puzzleBase64Array"
		/>
		<!-- <el-dialog :visible.sync="twoConfirmBoxFlag" width="30%" :before-close="beforeClose" class="dialog">
			<span slot="title" class="dialog-title">
				<i class="el-icon-warning-outline" style="margin-right: 12px;"></i>温馨提示
			</span>
			<div class="dialog-tip">是否删除该题目？</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="twoConfirmBoxFlag = false" :disabled="loading">取 消</el-button>
				<el-button type="primary" @click="twoConfirmClick" :loading="loading">确 定</el-button>
			</span>
		</el-dialog> -->

		<el-dialog :show-close="false" :visible.sync="imgFlag" :append-to-body="true" width="920px">
			<div style="display: flex; justify-content: center; padding: 10px; z-index: 2099; position: relative;">
				<i
					class="el-icon-close"
					_cursor="pointer"
					style="position: absolute; top: -20px; right: -18px; font-size: 20px;"
					@click="imgFlag = false"
				></i>
				<img :src="imgResource" style="width: 800px; max-height: 900px;" />
			</div>
		</el-dialog>

		<el-dialog :show-close="false" :visible.sync="videoFlag" :append-to-body="true" width="920px">
			<div style="display: flex; justify-content: center; padding: 10px; z-index: 2099; position: relative;">
				<i
					class="el-icon-close"
					_cursor="pointer"
					style="position: absolute; top: -20px; right: -18px; font-size: 20px;"
					@click="videoFlag = false"
				></i>
				<video ref="videoRef" @click.stop controls width="800" style="max-height:500px" :src="videoResource" controlslist="noplaybackrate"></video>
			</div>
		</el-dialog>

		<el-dialog :show-close="false" :visible.sync="audioFlag" :append-to-body="true" width="620px">
			<div style="display: flex; justify-content: center; padding: 10px; z-index: 2099; position: relative;">
				<i
					class="el-icon-close"
					_cursor="pointer"
					style="position: absolute; top: -20px; right: -18px; font-size: 20px;"
					@click="audioFlag = false"
				></i>
				<audio ref="audioRef" @click.stop controls :src="audioResource" controlslist="noplaybackrate"></audio>
			</div>
		</el-dialog>
	</div>
</template>
<script>
// import { SP51004, SP51005 } from '@/utils/permissionMap.js'
import { apply_grade, fb_apply_volume, audioTypes } from './const.js'
import { createPuzzlePieces } from '@/utils/puzzle'
import connectLine from './connectLine.vue'
import statistics from './statistics.vue'
import matchColorDetail from './matchColorDetail.vue'
import puzzleDetail from './puzzleDetail.vue'
import { throttle } from 'lodash'
import abcjs from "abcjs"
import colorFill from './colorFill.vue'
import matchColor from './matchColor.vue'
import fillColor from './fillColor.vue'
import html2canvas from 'html2canvas';
export default {
	components: {
		connectLine,
		statistics,
		matchColorDetail,
		puzzleDetail,
    colorFill,
    matchColor,
    fillColor
	},
	methods: {
		// filterBody(html){
		//   console.log(html.replace(/<\/?(img|table)[^>]*>/g, ""), '==========')
		//   return html.replace(/<\/?(img|table)[^>]*>/g, "")
		// },
		htmlClickImage(e) {
			const node = e.target
			if (node.nodeName == 'IMG') {
				const type = node.getAttribute('type')
				if (type == 'image') {
					this.imgFlag = true
					this.imgResource = node.getAttribute('src')
				} else if (type == 'audio') {
					this.audioFlag = true
					this.audioResource = node.getAttribute('data')
				} else if (type == 'video') {
					this.videoFlag = true
					this.videoResource = node.getAttribute('data')
				}
			}
		},
		async getKnowPointList() {
			const data = await this.$api.question_set.getKnowPointList()
			this.konwPointTags = data
		},
		async getPowerPointList() {
			const data = await this.$api.question_set.getPowerPointList()
			this.powerPointTags = data
		},
		loaded() {
			this.$refs.iframe.contentWindow.postMessage(
				{
					content: this.detailData,
					questionType: 'fillIn',
					unfold: false
				},
				'*'
			)
		},
    loadChange() {
      const iframe = this.$refs.iframe;
      if (iframe) {
        const getHeight = () => {
          const iframeDocument = iframe.contentWindow ? iframe.contentWindow.document : iframe.contentDocument;
          const targetElement = iframeDocument.getElementById('target');
          if (this.detailData.type == 4) {
            try {
              const fn = (win) => {
                if (win.vm) {
                  setTimeout(() => {
                    win.scoreElementChange('sing')
                  }, 1000);
                }
                else fn(win)
              }
              fn(iframe?.contentWindow)
              if (this.detailData.type !== 24) {
                this.musicBtnFlag = true
              }
            } catch(err) {
              console.log(err, '-232132131---')
            }
          } else {
            if (this.detailData.type !== 24) {
              this.musicBtnFlag = true
            }
          }
          const height = targetElement.style['min-height']
          if (height == '0px') {
            setTimeout(() => {
              getHeight()
            }, 300)
          } else {
            const num = Number(height.replace("px", ""))
            if (num < 1080 && num > 850) {
              this.iframeMarginBottom = '-47%'
            } else if (num < 850 && num > 750) {
              this.iframeMarginBottom = '-41%'
            } else if (num < 750 && num > 600) {
              this.iframeMarginBottom = '-35%'
            } else if (num < 600 && num > 200) {
              this.iframeMarginBottom = '-20%'
            } else if (num > 1080) {
              this.iframeMarginBottom = -57 - (num - 1080) / 29 + '%'
            }
            this.iframeMinHeight = num + 30 + 79
          }
        }
        getHeight()
        const iframeDocument = iframe.contentWindow ? iframe.contentWindow.document : iframe.contentDocument;
        const styleElement = iframeDocument.createElement('style');
        styleElement.textContent = `
            html, body {
              height: 100%;
            }
            #vm {
              height: 100%
            }
        `;
        const tool = iframeDocument.querySelector('.tool-container')
        if (tool) {
          tool.style.display = 'none'
        }
        iframeDocument.head.appendChild(styleElement);
      }
    },
		valueKeyLabel(e, array) {
			return array.find(item => {
				return item.value === e
			})?.label
		},
		routePush(pathName, row) {
			let path = `/workbench/abilityList/${this.params?.fb_subject_id || this.$route.params?.sbid}/${pathName}?id=${
				row.id
			}`
			this.$router.push(path)
		},
		routeJump: throttle(async function (id, index) {
      this.waitVisible = true
			if (id === '') return
			window.localStorage.setItem(
				'look-detail',
				JSON.stringify({
					id: id,
					index: index,
					total: this.total,
					params: {
						...this.params
					}
				})
      )
      const board = document.querySelector('.puzzle-board')
      if (board) {
        // 清空board的内容
        while (board.firstChild) {
          board.removeChild(board.firstChild);
        }
      }
			this.$router.push(
				`/workbench/abilityList/${this.params?.fb_subject_id || this.$route.params?.sbid}/look?id=${id}`
			)
			await this.initPage()
      this.waitVisible = false
		}, 100),
		routeBack() {
			// this.$router.go(-1)
			this.$router.push(`/workbench/abilityList/${this.params?.fb_subject_id || this.$route.params?.sbid}`)
		},
		async twoConfirmClick() {
			this.$confirm('此操作将永久删除, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				// this.loading = true
				const data = await this.$api.question_set.deleteQuestions(this.detailData.id)
				if (data.success) {
					// this.loading = false
					// this.twoConfirmBoxFlag = false
					if (this.total == 1) {
						this.routeBack()
					} else if (this.index == 1 && this.total > 1) {
						this.total -= 1
						this.routeJump(this.checkPage.next, this.index)
					} else if (this.index > 1 && this.total > 1) {
						this.total -= 1
						this.routeJump(this.checkPage.prev, this.index - 1)
					}
				} else {
					console.log('error')
				}
			})
		},
		async subjectTypeChangeEvent(e) {
			switch (e) {
				case '单选题' | 1:
					this.radioFormFlag = true
					this.moreRadioFormFlag = false
					this.gapFormFlag = false
					this.connectFormFlag = false
					this.srcResource = this.filterImg(this.detailData.body)
					this.filterBody = this.filterP(this.detailData.body)
					this.branches = this.detailData.branches.map(item => {
						return this.imgRepResource(item)
					})
					break
				case '多选题' | 2:
					this.radioFormFlag = false
					this.moreRadioFormFlag = true
					this.gapFormFlag = false
					this.connectFormFlag = false
					this.srcResource = this.filterImg(this.detailData.body)
					this.filterBody = this.filterP(this.detailData.body)
					this.branches = this.detailData.branches.map(item => {
						return this.imgRepResource(item)
					})
					break
				case '填空题' | 3:
					this.radioFormFlag = false
					this.moreRadioFormFlag = false
					this.gapFormFlag = true
					this.connectFormFlag = false
					this.srcResource = this.filterImg(this.detailData.body)
					this.filterBody = this.replaceBody(this.detailData.body)
					// this.filterBody = this.filterP(this.filterBody) //填空题修改样式
					break
				case '连线题' | 11:
					this.radioFormFlag = false
					this.moreRadioFormFlag = false
					this.gapFormFlag = false
					this.connectFormFlag = true
					this.srcResource = this.filterImg(this.detailData.body)
					this.filterBody = this.filterP(this.detailData.body)
					this.branches = {
            // left: this.detailData.branches.left,
            // right: this.detailData.branches.right
						left: this.detailData.branches.left.map(item => {
							return this.imgRepResource(item)
						}),
						right: this.detailData.branches.right.map(item => {
							return this.imgRepResource(item)
						})
					}
					// 如果是三组连线，插入 middle 字段
					if(this.detailData.extras[1]?.groupNum === 3){
						this.branches.middle = this.detailData.branches.middle.map(item => {
							return this.imgRepResource(item)
						})
					}
					break
        case '节奏题' | 4:
        case '视唱旋律题' | 5:
        case '演唱题' | 7:
        case '拾音练习题' | 18:
				case '可视化演唱题' | 9:
        case '弹奏题' | 24:
					this.radioFormFlag = false
					this.moreRadioFormFlag = false
					this.gapFormFlag = false
					this.connectFormFlag = false
					this.singFormFlag = true
					this.srcResource = this.filterImg(this.detailData.body)
					this.filterBody = this.filterP(this.detailData.body)
					this.getMusicalsDetail()
					break
				case '配色题' | 14:
					this.radioFormFlag = false
					this.moreRadioFormFlag = false
					this.gapFormFlag = false
					this.connectFormFlag = false
					this.singFormFlag = false
          this.detailData.extras = JSON.parse(this.detailData.extras)
          this.srcResource = this.filterImg(this.detailData.body)
					this.filterBody = this.filterP(this.detailData.body)
					break
        case '拼图题' | 13: {
          this.radioFormFlag = false
          this.moreRadioFormFlag = false
          this.gapFormFlag = false
          this.connectFormFlag = false
          this.singFormFlag = false
          this.detailData.extras = JSON.parse(this.detailData.extras)
          this.srcResource = this.filterImg(this.detailData.body)
          this.filterBody = this.filterP(this.detailData.body)
          await this.$nextTick()
          const board = document.querySelector('.puzzle-board')
          createPuzzlePieces(board, 450, this.detailData.extras.num, this.detailData.extras?.pic)
          await this.$nextTick()
          await new Promise(resolve => { setTimeout(() => { resolve() }, 1000) })
          const divs  = document.querySelector('.puzzle-board')
          const children = Array.from(divs.children);
          children.forEach(async (div, index) => {
            const canvasEl = await html2canvas(div, { useCORS: true })
            const image = canvasEl.toDataURL('image/png');
            this.puzzleBase64Array.push({ index: index + 1, url: image })
            if (index == children.length - 1) {
              await new Promise(resolve => { setTimeout(() => { resolve() }, 1000) })
              this.puzzleBase64Array = this.puzzleBase64Array.sort((a, b) => a.index - b.index);
            }
          })
					break
        }
        case '排序题' | 10:
          this.radioFormFlag = false
					this.moreRadioFormFlag = false
					this.gapFormFlag = false
					this.connectFormFlag = false
					this.singFormFlag = false
          this.srcResource = this.filterImg(this.detailData.body)
					this.filterBody = this.filterP(this.detailData.body)
          this.branches = this.detailData.branches.map(item => {
						return this.imgRepResource(item)
					})
					break

        case '填充题' | 12:
          this.radioFormFlag = false
					this.moreRadioFormFlag = false
					this.gapFormFlag = false
					this.connectFormFlag = false
					this.singFormFlag = false
          this.srcResource = this.filterImg(this.detailData.body)
					this.filterBody = this.filterP(this.detailData.body)
          break
			}
		},
		async getMusicalsDetail() {
      this.musicFlag = false
      this.musicBtnFlag = false
			try {
				const musciData = await this.$api.question_set.getMusicalsDetail(
					this.detailData.musical_id
				)
        const { abc_json_val, music, base_info } = musciData
				const abcContent = await this.$http({ url: abc_json_val.url })
				const vocalJson = music.reduce(
					(vocalJson, item, i) => {
            let code
            if (item?.audio_type > 10) { // 小于10的需要自己映射
              code = item?.type?.title
            } else {
              code = this.audioTypes[music[i]?.audio_type]?.CODE
            }
						vocalJson[code + '_URL'] = music[i].file_path.url
						const new_timeline = JSON.parse(music[i].new_timeline || '{}')
            vocalJson[code + '_WXP_BARLINE'] = new_timeline?.NODELINE_WXP ? new_timeline.NODELINE_WXP : ''
            // @ts-ignore 是否显示倒计时（预备拍)
            vocalJson[`${code}_COUNTDOWN_USE_METER`] = item.extra?.countdownUseMeter
						return vocalJson
					},
					{
						ABC_CONTENT: abcContent,
						SHOW_TYPE: this.detailData.type == 4 ? this.detailData.extras[1] : base_info.musicType === 'easy' ? 'jp' : 'wxp'
					}
				)
				window.top.music_datas = {}
				window.top.music_datas[this.detailData.musical_id] = { 
					VOCAL_JSON: vocalJson, 
					abcResData: musciData,
					visibility: {
            title: true,
            subhead: true,
            anAuthor: true,
            wordAuthor: true,
            speed: true,
            attr1: true,
            attr2: true,
            singAlongTitle: true
          }, 
				}
				this.musicFlag = true
        setInterval(() => {
          const el = window.top.music_datas[this.detailData.musical_id]?.singVm
          if (this.detailData.type == 24) {
            if (el?.strum?.isLoading == false) {
              this.musicBtnFlag = true
            } else {
              this.musicBtnFlag = false
            }
          }
          if (this.detailData.type === 18) {
            const typeIndex = 0
            el?.toolItemHandler(el?.tool.list[typeIndex], typeIndex)
          }
          if (el?.tool?.play === 'playing') this.playStop = true
          else {
            this.playStop = false
          }
        }, 400)
			} catch (err) {
				this.$message.error('引用的曲谱已被删除')
				this.hasMusicVisible = false
				this.musicFlag = false
			}
		},
		async musicPlay() {
			window.top.isFrontend = true
			const el = window.top.music_datas[this.detailData.musical_id].singVm
      const { tool, toolScorePlay, toolScoreStop, toolItemHandler } = el
			if (tool.play === 'stop') {
        this.playStop = true
        if (this.detailData.type === 18) {
          const typeIndex = 0
          toolItemHandler(tool.list[typeIndex], typeIndex)
          toolScorePlay(0)
        } else {
          toolScorePlay()
        }
      }
			else {
        this.playStop = false
        toolScoreStop()
      }
			const timer = setInterval(() => {
				const el = window.top.music_datas[this.detailData.musical_id].singVm
				if (el?.tool?.play === 'playing') this.playStop = true
				else {
					this.playStop = false
					clearInterval(timer)
				}
			}, 500)

      if (this.detailData.type == 24) {
        const iframe = this.$refs.iframe;
        const iframeDocument = iframe.contentWindow ? iframe.contentWindow.document : iframe.contentDocument;
        const puziBox = iframeDocument.querySelector('.puzi-box')
        const timer2 = setInterval(() => {
          if (!this.playStop) {
            clearInterval(timer2)
            puziBox.scrollTo({
              left: 0,
              behavior: "smooth"
            })
            return
          }
          let note = iframeDocument.querySelector('.note-light')
          if (note) {
            note.scrollIntoView({
              block: 'nearest', // 垂直方向不做特别处理
              inline: 'center',  // 水平方向左对齐
              behavior: 'smooth' // 平滑滚动效果
            })
          }
        }, 100)
      }
		},
		replaceBody(html) {
			let body = html
			this.detailData.answer.forEach(item => {
				body = body.replace('[@~]', item)
			})
			return body
		},
		filterP(html) {
			let str = ''
			const pLabel = html?.match(/<p>(.*?)<\/p>/g)
			pLabel?.forEach(item => {
				str += item.replace(/<\/?p>/g, '')
			})
			str = str.replace(/<br>(.*?)/g, '')
			return str
		},
		filterImg(html) {
			let arr = []
			const imgLabel = html?.match(/<img [^>]*src=['"]([^'"]+)[^>]*>/g)
			imgLabel?.forEach(item => {
				let src, type
				item.replace(/<img [^>]*data=['"]([^'"]+)[^>]*>/g, (match, capture) => {
					src = capture
				})
				item.replace(/<img [^>]*type=['"]([^'"]+)[^>]*>/g, (match, capture) => {
					type = capture
				})
				arr.push({ src, type })
			})
			return arr
		},
		imgRepResource(html) {
			let body = html
			body = body.replaceAll(/<img [^>]*type=['"]([^'"]+)[^>]*>/g, (match, capture) => {
				// if (capture === 'video' || capture === 'audio') {
				// 	let item = match.match(/data="([^"]*)"/)[1]
					// return `<${capture} style="width:300px" type="${capture}" controls src="${item}" controlslist="noplaybackrate nodownload"></${capture}>`
				// } else {
				// 	return match
				// }
        if (capture === 'image') {
          let item = match.match(/data="([^"]*)"/)[1]
          return `<img style="width:150px" src="${item}" type="image"></img>`
        } else {
          return match
        }
			})
			return body
		},
		async initPage() {
			this.hasMusicVisible = true
			this.singFormFlag = false
      this.musicFlag = false
			this.apply_grade = apply_grade
			this.fb_apply_volume = fb_apply_volume
			const { id, isJump } = this.$route.query
			this.scope_type = this.$route.query?.scope_type
			this.checkVisible = isJump == 'new' ? true : false
			if (!this.checkVisible) {
        try {
          const { index, total, params, startIndex } = JSON.parse(window.localStorage.getItem('look-detail'))
          this.index = Number(index)
          this.startIndex = startIndex
          this.total = total
          this.params = params
        } catch(err) {
          this.checkVisible = true
        }
			}
			const { question, next, prev } = await this.$api.question_set.getQuestionDetail(id, this.params)
			this.detailData = question
			this.iframeFlag = true
			this.checkPage = {
				next: next?.id,
				prev: prev?.id
			}
			this.createdFlag = true
			this.subjectTypeChangeEvent(this.detailData.type)
			window.addEventListener('message', this.iframeHeightBypostmessage)
		},
		iframeHeightBypostmessage(e) {
			if (e && e.data && e.data.code === 'height') {
				this.iframeHeight = e.data.content.height + 'px'
			}
		},
    playMidiNoteWithWebAudio(midi) {
      abcjs.synth.playEvent(
        [
          midi,
        ]
      ).then(function (response)  {
        console.log("note played");
      }).catch(function (error) {
        console.log("error playing note", error);
      });
    }
	},
	computed: {
		yy_ms() {
			return this.params?.fb_subject_id == 1 ? 'yy' : this.params?.fb_subject_id == 2 ? 'ms' : ''
		}
	},
	created() {
		// this.getKnowPointList()
		// this.getPowerPointList()
		this.initPage()
	},
  mounted() {
    // this.RESOURCE_URL = window.RESOURCE_URL
    this.RESOURCE_URL =  window.location.hostname !== 'localhost' ? window.web_config.server_url + window.web_config.music_score_display_path : window.RESOURCE_URL
  },
  watch: {
    audioFlag: {
      handler(vla) {
        if (!vla) {
          this.$refs?.audioRef?.pause()
        }
      }
    },
    videoFlag: {
      handler(vla) {
        if (!vla) {
          this.$refs?.videoRef?.pause()
        }
      }
    }
  },
	data() {
		return {
      puzzleBase64Array: [],
      iframeMarginBottom: '50%',
      iframeMinHeight: '1080',
      RESOURCE_URL: '',
			scope_type: '',
			audioTypes,
      waitVisible: false,
			checkVisible: false,
			hasMusicVisible: true,
			imgFlag: false,
			imgResource: '',
			videoFlag: false,
			videoResource: '',
			audioFlag: false,
			audioResource: '',
			musicFlag: false,
      musicBtnFlag: false,
			playStop: false,
			konwPointTags: [],
			powerPointTags: [],
			iframeHeight: '',
			// 选择题类型
			radioFormFlag: false,
			moreRadioFormFlag: false,
			gapFormFlag: false,
			connectFormFlag: false,
			singFormFlag: false,
			detailData: {},
			apply_grade: [],
			fb_apply_volume: [],
			twoConfirmBoxFlag: false,
			loading: false,
			createdFlag: false,
			srcResource: [],
			filterBody: '',
			total: 0,
			iframeFlag: false,
			branches: [] || {},
      startIndex: '',
      params: {},
      tool: {
        play: ''
      }
		}
	}
}
</script>
<style lang="scss" scoped>

.flex {
	display: flex;
}
.flex-align-center {
	display: flex;
	align-items: center;
}
.flex-center-center {
	display: flex;
	align-items: center;
	justify-content: center;
}
// .disabled {
// 	pointer-events: none;
// }
.ability-detail {
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	min-height: inherit;
	overflow: hidden;
	.ability-detail-header {
		display: flex;
		align-items: center;
		font-size: 16px;
		padding: 15px 15px 15px 25px;
		cursor: pointer;
	}
	.ability-detail-header:hover {
		color: #ff5e2a;
	}
	.ability-detail-subheader {
		display: flex;
		justify-content: space-between;
		background: #fbfbfb;
		height: 61px;
		margin-left: 21px;
	}
	.ability-detail-num {
		font-size: 16px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #565656;
		margin-right: 7px;
	}
	.ability-detail-id {
		width: 68px;
		height: 27px;
		background: #ebebeb;
		border-radius: 2px 2px 2px 2px;
		margin-right: 21px;
		font-size: 12px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #757575;
	}
	.ability-detail-row {
		height: 27px;
		background: #ebebeb;
		border-radius: 2px 2px 2px 2px;
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #757575;
		padding: 0 14px;
	}
	.ability-detail-total {
		margin-right: 8px;
		font-size: 12px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #757575;
	}
	.ability-detail-icon-left {
		width: 31px;
		height: 32px;
		background: #eeeeee;
		margin-right: 5px;
	}
	.button:hover {
		background: #ff5e2a;
		color: #ebebeb;
	}
	.button:focus {
		background: #ff5e2a;
		color: #ebebeb;
	}
	.ability-detail-icon-right {
		width: 31px;
		height: 32px;
		background: #eeeeee;
		// background: #ff5e2a;
		border-radius: 3px 3px 3px 3px;
		margin-right: 8px;
	}
	.ability-detail-button {
		width: 77px;
		height: 32px;
		background: #eeeeee;
		border-radius: 4px 4px 4px 4px;
		margin-right: 8px;
	}
	.ability-detail-body {
		max-width: max-content;
		// 左边对齐
		margin-left: 58px;
		display: flex;
		flex-direction: column;

		// align-items: center;
	}
	.ability-detail-body-title {
		:deep(p) {
			line-height: 1 !important;
      font-size: 24px !important
    }
		font-size: 24px !important;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #3e3e3e;
		margin-top: 40px;
		margin-bottom: 10px;
    margin-right: 58px;
		// max-width: 696px;
		min-width: 400px;
		display: flex;
		flex-wrap: wrap;
		align-items: baseline;
		// justify-content: center;
	}
	.ability-detail-resource {
		margin-bottom: 20px;
	}
  .gird {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 60px;
    max-width: 1080px;
  }
	.ability-detail-radio {
		// max-width: 696px;
    max-width: 500px;
		min-width: 400px;
		border-radius: 6px 6px 6px 6px;
		border: 1px solid #ffd4c6;
		display: flex;
		align-items: center;
		padding: 22px 10px;
		margin-bottom: 30px;
		overflow: hidden;
		.radio-item {
			display: flex;
			align-items: center;
			margin-left: 10px;
			flex: 1;
			max-height: 150px;
			overflow: auto;
		}
	}
	.ability-detail-radio-active {
		border: 1px solid #ff5e2a !important;
	}
	.ability-detail-audio {
		width: 330px;
	}
}
.dialog {
	/deep/ dialog-title {
		font-size: 18px;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #323232;
	}
	/deep/ .el-dialog__body {
		border-top: 2px solid #f8f8f8;
		border-bottom: 2px solid #f8f8f8;
		margin: 1px 20px;
	}
	/deep/ .el-dialog__footer {
		margin-top: 24px;
		margin-bottom: 25px;
	}
}
.dialog-tip {
	font-size: 18px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: bold;
	color: #323232;
	margin-top: 63px;
	margin-bottom: 52px;
	text-align: center;
}
.dialog-title {
	font-size: 18px;
	font-family: PingFang SC-Bold, PingFang SC;
	font-weight: bold;
	color: #d83a3a;
}

:deep(p) {
  font-size: 18px;
}

.puzzle-board {
	display: flex;
	flex-wrap: wrap;
	cursor: pointer;
}

.ability-detail-body-center {
  display: flex;
  justify-content: center;
}
</style>
